// GET USER LIST
export const USER_DATA = "USER_DATA"
export const USER_DATA_SUCCESS = "USER_DATA_SUCCESS"
export const ALL_USER_DATA_SUCCESS = "ALL_USER_DATA_SUCCESS"
export const USER_DATA_ERROR = "USER_DATA_ERROR"

// ADD NEW USER
export const ADD_NEW_USER = "ADD_NEW_USER"
export const ADD_NEW_USER_SUCCESS = "ADD_NEW_USER_SUCCESS"
export const ADD_NEW_USER_ERROR = "ADD_NEW_USER_ERROR"
// ADD NEW USER
export const UPDATE_NEW_USER = "UPDATE_NEW_USER"
export const UPDATE_NEW_USER_SUCCESS = "UPDATE_NEW_USER_SUCCESS"
export const UPDATE_NEW_USER_ERROR = "UPDATE_NEW_USER_ERROR"

// USER DEVICES / PRIMARY COMPUTER
export const GET_USER_DEVICES = "GET_USER_DEVICES"
export const GET_USER_DEVICES_SUCCESS = "GET_USER_DEVICES_SUCCESS"
export const GET_USER_DEVICES_ERROR = "GET_USER_DEVICES_ERROR"

export const SET_PRIMARY_DEVICE = "SET_PRIMARY_DEVICE"
export const SET_PRIMARY_DEVICE_SUCCESS = "SET_PRIMARY_DEVICE_SUCCESS"
export const SET_PRIMARY_DEVICE_ERROR = "SET_PRIMARY_DEVICE_ERROR"

//BULK UPLOAD
export const BULK_UPLOAD = "BULK_UPLOAD"
export const BULK_UPLOAD_SUCCESS = "BULK_UPLOAD_SUCCESS"
export const BULK_UPLOAD_ERROR = "BULK_UPLOAD_ERROR"

//UPDATE ATTENDANCE
export const UPDATE_ATTENDANCE = "UPDATE_ATTENDANCE"

//UPDATE TIMESHEET
export const UPDATE_TIMESHEET = "UPDATE_TIMESHEET"

//UPDATE NON REPORT PENALTY
export const UPDATE_PENALTY = "UPDATE_PENALTY"

